import styled from '@mui/material/styles/styled';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';

export const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.accent,
  borderLeft: '4px solid',
  borderColor: theme.palette.primary.main,
  padding: '8px 12px',
  gap: 8,
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    alignItems: 'center',
    flexDirection: 'row',
    padding: '12px 16px',
    gap: 16
  }
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flex: 1,
  paddingRight: 32,
  [theme.breakpoints.up('sm')]: {
    paddingRight: 0
  }
}));

export const TimerWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  paddingLeft: 28,
  [theme.breakpoints.up('sm')]: {
    gap: 16,
    paddingLeft: 0
  }
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: '#fff',
  fontWeight: 600,
  fontSize: '0.75rem',
  height: 28,
  '& .MuiChip-icon': { 
    color: '#fff' 
  },
  '& .MuiChip-label': { 
    padding: '0 8px' 
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '0.875rem',
    height: 32,
    '& .MuiChip-label': { 
      padding: '0 12px' 
    }
  }
}));

export const StyledInfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 20,
  [theme.breakpoints.up('sm')]: {
    fontSize: 22
  }
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
  fontSize: '0.8rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '0.875rem'
  }
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  opacity: 0.8,
  fontSize: '0.75rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '0.875rem'
  }
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  padding: 4,
  position: 'absolute',
  top: 8,
  right: 8,
  [theme.breakpoints.up('sm')]: {
    position: 'static',
    top: 'auto',
    right: 'auto'
  }
}));

export const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  fontSize: 18,
  [theme.breakpoints.up('sm')]: {
    fontSize: 20
  }
}));
